import { render, staticRenderFns } from "./GebruikersBase.vue?vue&type=template&id=e6c3e41a&scoped=true&"
import script from "./GebruikersBase.vue?vue&type=script&lang=js&"
export * from "./GebruikersBase.vue?vue&type=script&lang=js&"
import style0 from "./GebruikersBase.vue?vue&type=style&index=0&id=e6c3e41a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c3e41a",
  null
  
)

export default component.exports